import React from 'react';
import Modal from 'components/Modal';
import { observer } from 'mobx-react';
import { Form } from 'components/Form';
import { Dialog, DialogContent, DialogFooter, DialogButton } from 'components/Dialog';
import Button from 'components/Button';
import styles from './ApproveDraftDialog.m.sass';
import YesNo from '../../../../assets/img/prompt-yes-no-dialog.svg';
var ApproveDraftDialog = observer(function (_ref) {
  var store = _ref.store;
  if (!store.jobProgression) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Modal, {
    isOpened: store.showing,
    onRequestClose: store.hide
  }, /*#__PURE__*/React.createElement(Dialog, null, /*#__PURE__*/React.createElement(Form, {
    onSubmit: store.approveDraft
  }, /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("div", {
    className: styles.dialog
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.image,
    src: YesNo
  }), /*#__PURE__*/React.createElement("h2", {
    className: styles.title
  }, "Are you sure that you approve the latest draft return?"), /*#__PURE__*/React.createElement("p", {
    className: styles.subtitle
  }, "If accepted, the Pro will be able to close the job."))), /*#__PURE__*/React.createElement(DialogFooter, {
    bordered: true
  }, /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    onClick: store.hide
  }, "Cancel"), /*#__PURE__*/React.createElement(DialogButton, {
    submit: store.approveDraft,
    primary: true,
    dataTest: "job-progression-confirm-draft-approved-button"
  }, "Yes")))));
});
export default ApproveDraftDialog;
//# sourceMappingURL=index.js.map
